import onLoadShared from "../shared/on_load"
onLoadShared.run()

import onLoad from "../sites/coaching/on_load"
onLoad.run()
